import { objectWithoutProperties as _objectWithoutProperties, extends as _extends, objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef, useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import Box from '@mui/material/Box';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import InputAdornment from '@mui/material/InputAdornment';
import { isBoolean, isEmpty, get, isArray } from 'lodash-es';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import { StyledAutoCompleteContainer, StyledAutoComplete, StyledSelectItemMoreBtn, StyledAutoCompleteTextField, StyledCustomPaper } from './AutoCompleteDropdown.styles.js';
import arbitrumSVG from '../assets/img/arbitrum.svg.js';
import AVAXPNG from '../assets/img/avax.png.js';
import BSCSVG from '../assets/img/BSC.svg.js';
import ETHPNG from '../assets/img/ETH.png.js';
import OptimismPNG from '../assets/img/op.png.js';
import PolygonPNG from '../assets/img/polygon.png.js';
import Checkbox from '../Checkbox/Checkbox.js';
import MetaCRMTag from '../MetaCRMTag/MetaCRMTag.js';
import useHandleError from '../hooks/useHandleError.hooks.js';
const _excluded = ["isTag", "isOptionPreview", "currOptionHovered", "children", "maxHeightDropdownMenu", "customNodeInOption"],
  _excluded2 = ["children", "onClose", "onHandleOption"],
  _excluded3 = ["size", "options", "value", "name", "isOptionEqualToValue", "comparativeValue", "onChange", "inputRef", "renderTags", "renderOptions", "placeholder", "readonly", "readonlyProps", "showPlaceholderHaveValue", "isTag", "onHandleOption", "onEnter", "limitTags", "onClick", "onClose", "withIcon", "control", "rules", "errors", "errorTextAbsolute", "noRenderErrorText", "prefix", "noBorder", "focusBorderWidth", "isOptionPreview", "maxHeightDropdownMenu", "disableCloseOnSelect", "select", "max", "customNodeInOption", "isInputFieldBehaviour", "isShowBorderError", "multiple"],
  _excluded4 = ["onDelete"],
  _excluded5 = ["className"],
  _excluded6 = ["onChange"];
const chainList = [{
  label: 'Ethereum',
  value: '1',
  name: 'Ethereum',
  imgURL: ETHPNG
}, {
  label: 'Polygon',
  value: '137',
  name: 'Polygon',
  imgURL: PolygonPNG
}, {
  label: 'Arbitrum',
  value: '42161',
  name: 'Arbitrum',
  imgURL: arbitrumSVG
}, {
  label: 'BSC',
  value: '56',
  name: 'BSC',
  imgURL: BSCSVG
}, {
  label: 'Avalanche',
  value: '43114',
  name: 'Avalanche',
  imgURL: AVAXPNG
}, {
  label: 'Optimism',
  value: '10',
  name: 'Optimism',
  imgURL: OptimismPNG
}];
const defaultField = {
  onChange: () => {},
  onBlur: () => {},
  value: null,
  name: ''
};

// eslint-disable-next-line react/prop-types
const ListboxComponent = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      isTag,
      isOptionPreview,
      currOptionHovered,
      children,
      maxHeightDropdownMenu,
      customNodeInOption
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement(Box, _extends({}, otherProps, {
    ref: ref,
    style: _objectSpread2({
      maxHeight: maxHeightDropdownMenu
    }, isOptionPreview && {
      height: maxHeightDropdownMenu,
      display: 'flex',
      flexDirection: 'row',
      overflowY: 'none',
      padding: 0
    })
  }), customNodeInOption, /*#__PURE__*/React__default.createElement(Box, {
    component: "ul",
    style: _objectSpread2({}, isOptionPreview && {
      width: '60%',
      height: '100%',
      overflowY: 'auto'
    })
  }, children), isOptionPreview && /*#__PURE__*/React__default.createElement(Box, {
    style: {
      height: '100%',
      width: '40%',
      minWidth: '250px',
      backgroundColor: '#fff'
    }
  }, get(currOptionHovered, 'optionPreview', false) && /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: '100%',
      height: '100%'
    }
  }, currOptionHovered.optionPreview)));
});
const optionType = PropTypes.shape({
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  labelComponent: PropTypes.node,
  isAllOption: PropTypes.bool,
  disabled: PropTypes.bool,
  readonly: PropTypes.bool,
  optionPreview: PropTypes.node
});
ListboxComponent.propTypes = {
  isTag: PropTypes.bool,
  isOptionPreview: PropTypes.bool,
  currOptionHovered: PropTypes.oneOfType([PropTypes.arrayOf(optionType), optionType]),
  children: PropTypes.arrayOf(PropTypes.node),
  maxHeightDropdownMenu: PropTypes.string,
  customNodeInOption: PropTypes.node
};
ListboxComponent.defaultProps = {
  isTag: false,
  isOptionPreview: false,
  currOptionHovered: null,
  children: [],
  maxHeightDropdownMenu: '250px',
  customNodeInOption: null
};

// eslint-disable-next-line react/prop-types
const PaperComponent = /*#__PURE__*/forwardRef((_ref2, ref) => {
  let {
      children,
      onClose,
      onHandleOption
    } = _ref2,
    otherProps = _objectWithoutProperties(_ref2, _excluded2);
  const renderPaper = () => /*#__PURE__*/React__default.createElement(StyledCustomPaper, _extends({
    onHandleOption: onHandleOption
  }, otherProps, {
    ref: ref
  }), children);
  if (onClose) {
    return /*#__PURE__*/React__default.createElement(ClickAwayListener, {
      onClickAway: onClose
    }, renderPaper());
  }
  return renderPaper();
});

// 兩個array取差集
function getArrayDifferenceUsingIncludes(arr1, arr2) {
  const valuesInArr2 = arr2.map(item => item.value);
  return arr1.filter(item => !valuesInArr2.includes(item.value));
}
const AutoCompleteDropdown = /*#__PURE__*/forwardRef((_ref3, ref) => {
  let {
      size,
      options,
      value,
      name,
      isOptionEqualToValue,
      comparativeValue,
      onChange,
      inputRef,
      renderTags,
      renderOptions,
      placeholder,
      readonly,
      readonlyProps,
      // just for multiple select
      showPlaceholderHaveValue,
      isTag,
      onHandleOption,
      onEnter,
      limitTags,
      onClick,
      onClose,
      withIcon,
      control,
      rules,
      errors,
      errorTextAbsolute,
      noRenderErrorText,
      prefix,
      noBorder,
      focusBorderWidth,
      isOptionPreview,
      maxHeightDropdownMenu,
      disableCloseOnSelect,
      select,
      max,
      customNodeInOption,
      isInputFieldBehaviour,
      isShowBorderError,
      multiple
    } = _ref3,
    otherProps = _objectWithoutProperties(_ref3, _excluded3);
  const [currentOptionHovered, setCurrentOptionHovered] = useState(options[0]);
  const hasError = isBoolean(errors) ? errors : !isEmpty(errors);
  const {
    renderErrorText
  } = useHandleError({
    hasError,
    noRenderErrorText,
    errorTextAbsolute
  });
  const handleIsOptionEqualToValue = (option, newValue) => {
    if (isOptionEqualToValue) return isOptionEqualToValue(option, newValue);
    return option[comparativeValue] === newValue[comparativeValue];
  };
  const handleAllOptions = (event, newValue, onFormChange) => {
    const isAllOptionInCurrentValue = isArray(value) ? value.find(_ref4 => {
      let {
        isAllOption
      } = _ref4;
      return isAllOption;
    }) : value;
    const filterNewValue = isAllOptionInCurrentValue ?
    // eslint-disable-next-line no-prototype-builtins
    newValue.filter(item => !item.hasOwnProperty('isAllOption')) :
    // eslint-disable-next-line no-prototype-builtins
    newValue.filter(item => item.hasOwnProperty('isAllOption') || item.isAllOption);
    onChange(event, filterNewValue);
    onFormChange(filterNewValue);
  };
  const handleChangeDropdown = (event, newValue, onFormChange) => {
    const isMultiple = isArray(newValue);
    const isAllOptionInNewValue = isMultiple ? newValue.find(_ref5 => {
      let {
        isAllOption
      } = _ref5;
      return isAllOption;
    }) : false;
    if (isAllOptionInNewValue) {
      handleAllOptions(event, newValue, onFormChange);
      return;
    }
    if (isMultiple) {
      if (max && newValue.length > max) {
        return;
      }
      const differenceOnlyAll = getArrayDifferenceUsingIncludes(options, newValue).length === 1 && getArrayDifferenceUsingIncludes(options, newValue)[0].isAllOption;
      if (differenceOnlyAll) {
        const valueToSet = getArrayDifferenceUsingIncludes(options, newValue);
        onChange(event, valueToSet);
        onFormChange(valueToSet);
        return;
      }
    }
    if (newValue !== null && newValue !== void 0 && newValue.readonly) {
      onChange(_objectSpread2(_objectSpread2({}, event), {}, {
        target: _objectSpread2(_objectSpread2({}, event && event.target), {}, {
          name,
          value: _objectSpread2(_objectSpread2({}, newValue), {}, {
            value: '',
            label: placeholder
          })
        })
      }), _objectSpread2(_objectSpread2({}, newValue), {}, {
        value: '',
        label: placeholder
      }), name);
      onFormChange(_objectSpread2(_objectSpread2({}, newValue), {}, {
        value: placeholder
      }));
      return;
    }
    onChange(_objectSpread2(_objectSpread2({}, event), {}, {
      target: _objectSpread2(_objectSpread2({}, event && event.target), {}, {
        name,
        value: newValue
      })
    }), newValue, name);
    onFormChange(newValue);
  };

  // 多選的渲染結果
  const handleRenderTags = (selectedValues, getTagProps) => {
    if (!renderTags) {
      if (isTag) {
        return selectedValues.map((item, index) => /*#__PURE__*/React__default.createElement(MetaCRMTag, _extends({
          option: item
        }, getTagProps({
          index
        })), item.label));
      }
      return selectedValues.map((item, index) => {
        const _getTagProps = getTagProps({
            index
          }),
          {
            onDelete
          } = _getTagProps,
          otherGetTagProps = _objectWithoutProperties(_getTagProps, _excluded4);
        return /*#__PURE__*/React__default.createElement(Box, _extends({}, otherGetTagProps, {
          p: "2px 8px 2px 12px",
          bgcolor: "#F2F2F2",
          borderRadius: "4px",
          color: "#555",
          mr: "8px",
          display: "flex",
          alignItems: "center"
        }), item.label, ' ', /*#__PURE__*/React__default.createElement(Box, {
          onClick: onDelete,
          sx: {
            cursor: 'pointer'
          }
        }, /*#__PURE__*/React__default.createElement("i", {
          className: "meta-crm-icon-ic_cancel font-size-10",
          style: {
            marginLeft: '8px'
          }
        })));
      });
    }
    return renderTags({
      selectedValues,
      getTagProps
    });
  };
  const handleOptionClickEdit = (event, option) => {
    event.stopPropagation();
    onHandleOption(event, option);
  };

  // 渲染選項
  const handleRenderOptions = (props, option, _ref6) => {
    let {
      selected
    } = _ref6;
    if (renderOptions) {
      return renderOptions(props, option);
    }
    if (multiple) {
      // eslint-disable-next-line react/prop-types
      const {
          className
        } = props,
        otherOptionProps = _objectWithoutProperties(props, _excluded5);
      if (isTag) {
        return /*#__PURE__*/React__default.createElement(Box, _extends({
          component: "li",
          className: "checkbox ".concat(className)
        }, otherOptionProps, {
          sx: _objectSpread2(_objectSpread2({}, (option === null || option === void 0 ? void 0 : option.disabled) && {
            pointerEvents: 'none',
            opacity: 0.6
          }), {}, {
            '&.MuiAutocomplete-option': {
              display: 'flex',
              justifyContent: 'space-between'
            }
          })
        }), /*#__PURE__*/React__default.createElement(MetaCRMTag, {
          option: option,
          backgroundColor: option.color
        }, option.label), !onHandleOption && /*#__PURE__*/React__default.createElement(Checkbox, {
          checked: selected,
          customColor: "#7B61FF",
          boxBackgroundColor: "transparent",
          boxBorderColor: "transparent",
          checkboxSize: "24px"
        }), onHandleOption && /*#__PURE__*/React__default.createElement(StyledSelectItemMoreBtn, {
          sx: {
            marginLeft: 'auto'
          },
          onClick: event => handleOptionClickEdit(event, option)
        }, /*#__PURE__*/React__default.createElement(MoreHorizIcon, null)));
      }
      return /*#__PURE__*/React__default.createElement(Box, _extends({
        component: "li",
        className: "checkbox ".concat(className)
      }, otherOptionProps, {
        sx: _objectSpread2(_objectSpread2({}, (option === null || option === void 0 ? void 0 : option.disabled) && {
          pointerEvents: 'none',
          opacity: 0.6
        }), {}, {
          '&.MuiAutocomplete-option': {
            display: 'flex',
            justifyContent: 'space-between'
          }
        })
      }), option.label, /*#__PURE__*/React__default.createElement(Checkbox, {
        checked: selected,
        customColor: "#7B61FF",
        boxBackgroundColor: "transparent",
        boxBorderColor: "transparent",
        checkboxSize: "24px"
      }));
    }
    if (isTag) {
      return /*#__PURE__*/React__default.createElement(Box, _extends({
        component: "li"
      }, props, {
        style: _objectSpread2({}, (option === null || option === void 0 ? void 0 : option.disabled) && {
          pointerEvents: 'none',
          opacity: 0.6
        })
      }), /*#__PURE__*/React__default.createElement(MetaCRMTag, {
        option: option,
        backgroundColor: option.color
      }, option.label), /*#__PURE__*/React__default.createElement(Checkbox, {
        checked: selected,
        customColor: "#7B61FF",
        boxBackgroundColor: "transparent",
        boxBorderColor: "transparent",
        checkboxSize: "24px"
      }), ' ', onHandleOption && /*#__PURE__*/React__default.createElement(StyledSelectItemMoreBtn, {
        sx: {
          marginLeft: 'auto'
        },
        onClick: event => handleOptionClickEdit(event, option)
      }, /*#__PURE__*/React__default.createElement(MoreHorizIcon, null)));
    }
    if (withIcon) {
      return /*#__PURE__*/React__default.createElement(Box, _extends({
        component: "li"
      }, props, {
        key: option.value,
        style: _objectSpread2(_objectSpread2({}, (option === null || option === void 0 ? void 0 : option.disabled) && {
          pointerEvents: 'none',
          opacity: 0.6
        }), {}, {
          justifyContent: 'space-between'
        })
      }), /*#__PURE__*/React__default.createElement(Box, {
        sx: {
          display: 'flex',
          alignItems: 'center'
        }
      }, /*#__PURE__*/React__default.createElement(Box, {
        width: "20px",
        height: "20px",
        margin: "2px 5px 2px 2px",
        component: "img",
        src: option.imgURL,
        alt: "option-icon"
      }), option.label), /*#__PURE__*/React__default.createElement(Checkbox, {
        checked: selected,
        customColor: "#7B61FF",
        boxBackgroundColor: "transparent",
        boxBorderColor: "transparent",
        checkboxSize: "24px"
      }));
    }
    return /*#__PURE__*/React__default.createElement("li", _extends({}, props, {
      key: option.value,
      onMouseEnter: () => setCurrentOptionHovered(option),
      style: _objectSpread2(_objectSpread2({}, (option === null || option === void 0 ? void 0 : option.disabled) && {
        pointerEvents: 'none',
        opacity: 0.6
      }), {}, {
        justifyContent: 'space-between'
      })
    }), option !== null && option !== void 0 && option.labelComponent ? option.labelComponent : option.label, /*#__PURE__*/React__default.createElement(Checkbox, {
      checked: selected,
      customColor: "#7B61FF",
      boxBackgroundColor: "transparent",
      boxBorderColor: "transparent",
      checkboxSize: "24px"
    }));
  };
  const renderPlaceholder = () => {
    if (!showPlaceholderHaveValue && !isEmpty(value)) {
      return '';
    }
    return placeholder;
  };
  const handleKeyDown = event => {
    const {
      keyCode,
      target
    } = event;
    if (keyCode === 13) {
      if (target.value.trim()) {
        onEnter(target.value, event);
      }
    }
  };
  const renderStartAdornment = params => {
    var _options$find;
    const targetImgUrl = (value === null || value === void 0 ? void 0 : value.imgURL) || ((_options$find = options.find(option => option.value === value)) === null || _options$find === void 0 ? void 0 : _options$find.imgURL);
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, prefix && prefix, targetImgUrl && /*#__PURE__*/React__default.createElement(InputAdornment, {
      position: "start"
    }, /*#__PURE__*/React__default.createElement(Box, {
      width: "20px",
      height: "20px",
      margin: "2px -6px 2px 2px",
      component: "img",
      src: targetImgUrl,
      alt: "value-icon"
    })), params.InputProps.startAdornment);
  };
  const handleRenderInput = params => /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(StyledAutoCompleteTextField, _extends({}, params, {
    inputRef: inputRef,
    placeholder: renderPlaceholder(),
    onKeyDown: handleKeyDown,
    disabled: select,
    isSelect: select,
    InputProps: _objectSpread2(_objectSpread2({}, params.InputProps), {}, {
      startAdornment: renderStartAdornment(params)
    }),
    noBorder: noBorder
  })));
  const renderAutoComplete = _ref7 => {
    let {
        field: {
          onChange: onFormChange
        }
      } = _ref7,
      field = _objectWithoutProperties(_ref7.field, _excluded6);
    return /*#__PURE__*/React__default.createElement(StyledAutoCompleteContainer, null, readonly ? /*#__PURE__*/React__default.createElement(Box, readonlyProps, (value === null || value === void 0 ? void 0 : value.label) || value || '-') : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(StyledAutoComplete, _extends({}, field, otherProps, {
      multiple: multiple,
      sx: {
        width: '100%'
      },
      disableClearable: true,
      size: size,
      isTag: isTag,
      popupIcon: !isInputFieldBehaviour ? /*#__PURE__*/React__default.createElement(KeyboardArrowDownIcon, null) : null,
      limitTags: limitTags,
      options: options,
      hasError: hasError,
      isShowBorderError: isShowBorderError,
      renderTags: handleRenderTags,
      onChange: (event, newValue) => {
        handleChangeDropdown(event, newValue, onFormChange);
      },
      value: value,
      isOptionEqualToValue: handleIsOptionEqualToValue
      // isOptionEqualToValue={(option, newValue) =>
      // 	option[comparativeValue] === newValue[comparativeValue]
      // }
      ,

      renderOption: handleRenderOptions,
      ListboxComponent: ListboxComponent,
      ListboxProps: {
        isTag,
        isOptionPreview,
        currOptionHovered: currentOptionHovered,
        maxHeightDropdownMenu,
        customNodeInOption
      },
      renderInput: handleRenderInput,
      PaperComponent: PaperComponent,
      componentsProps: {
        paper: {
          isTag,
          onClose,
          onHandleOption
        },
        popper: {
          disablePortal: true
        }
      },
      noBorder: noBorder,
      focusBorderWidth: focusBorderWidth,
      disableCloseOnSelect: disableCloseOnSelect
    })), hasError && renderErrorText(errors)));
  };
  return /*#__PURE__*/React__default.createElement(Box, {
    width: "100%",
    onClick: onClick
  }, control ? /*#__PURE__*/React__default.createElement(Controller, {
    name: name,
    control: control,
    rules: rules,
    render: renderAutoComplete
  }) : renderAutoComplete({
    field: defaultField
  }));
});
AutoCompleteDropdown.propTypes = {
  options: PropTypes.arrayOf(optionType).isRequired,
  value: PropTypes.oneOfType([PropTypes.arrayOf(optionType), optionType]),
  size: PropTypes.oneOf(['extraLarge', 'large', 'medium', 'small', 'extraSmall']),
  name: PropTypes.string,
  isOptionEqualToValue: PropTypes.func,
  comparativeValue: PropTypes.string,
  onChange: PropTypes.func,
  inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.instanceOf(Element)
  })]),
  renderTags: PropTypes.func,
  renderOptions: PropTypes.func,
  placeholder: PropTypes.string,
  readonly: PropTypes.bool,
  readonlyProps: PropTypes.shape({}),
  // just for multiple select
  showPlaceholderHaveValue: PropTypes.bool,
  isTag: PropTypes.bool,
  onHandleOption: PropTypes.func,
  onEnter: PropTypes.func,
  limitTags: PropTypes.number,
  onClick: PropTypes.func,
  onClose: PropTypes.func,
  withIcon: PropTypes.bool,
  /**
   * react-hook-form control
   */
  control: PropTypes.shape({}),
  rules: PropTypes.shape({}),
  errors: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]),
  errorTextAbsolute: PropTypes.bool,
  noRenderErrorText: PropTypes.bool,
  prefix: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  focusBorderWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  noBorder: PropTypes.bool,
  isOptionPreview: PropTypes.bool,
  maxHeightDropdownMenu: PropTypes.string,
  disableCloseOnSelect: PropTypes.bool,
  select: PropTypes.bool,
  max: PropTypes.number,
  customNodeInOption: PropTypes.node,
  isInputFieldBehaviour: PropTypes.bool,
  isShowBorderError: PropTypes.bool,
  multiple: PropTypes.bool
};
AutoCompleteDropdown.defaultProps = {
  value: null,
  size: 'extraLarge',
  name: '',
  isOptionEqualToValue: null,
  comparativeValue: 'value',
  onChange: () => {},
  inputRef: null,
  renderTags: null,
  renderOptions: null,
  readonly: false,
  readonlyProps: {},
  placeholder: 'Select',
  showPlaceholderHaveValue: false,
  isTag: false,
  onHandleOption: undefined,
  onEnter: () => {},
  limitTags: 3,
  onClick: null,
  onClose: null,
  withIcon: false,
  control: null,
  rules: {},
  errors: null,
  errorTextAbsolute: true,
  noRenderErrorText: false,
  prefix: null,
  noBorder: false,
  focusBorderWidth: '2px',
  isOptionPreview: false,
  maxHeightDropdownMenu: '250px',
  disableCloseOnSelect: false,
  select: false,
  max: null,
  customNodeInOption: null,
  isInputFieldBehaviour: false,
  isShowBorderError: false,
  multiple: false
};
var AutoCompleteDropdown$1 = AutoCompleteDropdown;
export { chainList, AutoCompleteDropdown$1 as default };